// extracted by mini-css-extract-plugin
module.exports = {"container":"qT","content":"qU","title":"qV","mb60":"qW","listItem":"qX","listItemText":"qY","goBack":"qZ","goBackText":"q0","header":"q1","closeBtn":"q2","subcategoryBtn":"q3"};